import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { detectInitialLocale, storeLocale } from "./localeStorage";
import { loadLocaleDisplayFont } from "./localeDisplayFonts";
import { isRtlLocale, normalizeLocale, SUPPORTED_LOCALES } from "./locales";
import { i18nResources } from "./resources";

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
    name: "pbtgLocale",
    lookup: detectInitialLocale,
});

function applyDocumentLocale(value: string): void {
    const locale = normalizeLocale(value) ?? "en";
    document.documentElement.lang = locale;
    document.documentElement.dir = isRtlLocale(locale) ? "rtl" : "ltr";
    loadLocaleDisplayFont(locale);
    storeLocale(locale);
}

i18n.on("initialized", () => {
    applyDocumentLocale(i18n.language ?? i18n.resolvedLanguage);
});
i18n.on("languageChanged", applyDocumentLocale);

void i18n
    .use(languageDetector)
    .use(initReactI18next)
    .init({
        resources: i18nResources,
        fallbackLng: "en",
        supportedLngs: [...SUPPORTED_LOCALES],
        load: "currentOnly",
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
        detection: {
            order: ["pbtgLocale"],
            caches: [],
        },
    });

export default i18n;
